import { memo, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { DashboardSidebar } from './DashboardSidebar';
import { DashboardHeader } from './DashboardHeader';
import { PrivacyProvider } from '../../context/PrivacyContext';
import { getPageTitleKey } from './navConfig';
import './dashboard.css';

const MemoizedSidebar = memo(DashboardSidebar);

export const DashboardV2Layout = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const pageTitleKey = useMemo(
    () => getPageTitleKey(location.pathname),
    [location.pathname],
  );

  return (
    <PrivacyProvider>
      <div className="dashboard-root">
        <MemoizedSidebar />
        <main className="dashboard-main">
          <DashboardHeader title={t(pageTitleKey)} />
          <div className="dashboard-content custom-scrollbar">
            <Outlet />
          </div>
        </main>
      </div>
    </PrivacyProvider>
  );
};

export default DashboardV2Layout;
